require('./bootstrap');
import {store} from './store'
import axios from 'axios'
import 'vue2-datepicker/index.css';
import vueDebounce from 'vue-debounce'
import Toasted from 'vue-toasted';
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

window.Vue = require('vue').default;
library.add(fas);

import { flare } from "@flareapp/js";

// Only enable Flare in production, we don't want to waste your quota while you're developing:
if (process.env.NODE_ENV === 'production') {
	flare.light();
}

Vue.use(Toasted)
Vue.use(vueDebounce)

function waitForLocalStorage(key, cb, timer) {
	if ( ! localStorage.getItem( key ) ) {
		return timer = setTimeout(
			waitForLocalStorage.bind( null, key, cb ),
			100
		)
	}
	clearTimeout( timer )
	if ( typeof cb !== 'function' ) {
		return localStorage.getItem( key )
	}
	return cb( localStorage.getItem( key ) )
}
function appInstance(apiToken) {
	const locationPath = location.pathname.split('/')
	 const axiosInstance = axios.create({
		headers: {
			'Content-Type': 'application/json',
			accept: 'application/json',
			Authorization: 'Bearer ' + apiToken,
			"Accept-School-Type": 'academic',
			'Accept-Currency': localStorage.getItem('currencyCode') ? localStorage.getItem('currencyCode') : store.getters['global/currencyGetter'],
			'Accept-Language': (locationPath.includes('az') || locationPath.includes('en')) && locationPath[1] ? locationPath[1] : 'tr'
		}
	})
	Vue.component('font-awesome-icon', FontAwesomeIcon)

	axiosInstance.interceptors.response.use(
		(response) => {
			return response
		},
		(error) => {
			if(error.response.status === 419) {
				$("#csrfModal").modal('show');
			}
			if (error.response.data && error.response.data.errors || error.response.data && error.response.data.result && error.response.data.result.errors) {
				const errors = error.response.data.errors || error.response.data.result.errors
				Object.keys(errors).forEach(err => {
					Vue.toasted.show(errors[err][0], {
						theme: "bubble",
						class: 'error-notification',
						position: "top-right",
						duration: 3000
					})
				})
			}
			throw error
		}
	)
	axiosInstance.interceptors.response.use(
		(response) => {
			return response
		},
		(error) => {
			throw error
		}
	)

	Vue.prototype.$axios = axiosInstance
	store.$axios = Vue.prototype.$axios

	store.dispatch('global/getInit')

	Vue.mixin({
		data() {
			return {
				innerWidth: null,
				emitPlacesData: [],
			}
		},
		created() {
			this.innerWidth = window.innerWidth
			window.addEventListener('resize', this.handleResizeEvent)
		},
		destroyed() {
			window.removeEventListener('resize', this.handleResizeEvent)
		},
		computed: {
			currencySymbol() {
				return localStorage.getItem('currencySymbol') ? localStorage.getItem('currencySymbol') : store.getters['global/currencySymbolGetter']
			},
			isLoggedIn() {
				return localStorage.getItem('api-user-token')
			}
		},
		methods: {
			emitPlaces(emitPlaces) {
				emitPlaces.forEach((place, index) => {
					this.emitPlacesData = this.emitPlacesData.concat(place.cities)
					this.emitPlacesData = this.emitPlacesData.concat(place)
				})
			},
			getURL(route, page, school, filters, language = null) {
				if (language === null) {
					language = JSON.parse(document.getElementsByName('current_language')[0].getAttribute('content'));
				}

				if (language && language.language == 'tr')
					language = null;

				var foundPlace = null
				foundPlace = this.emitPlacesData.find(x => x.key == school.place_id)

				var programType = '';

				// if ('program_type' in filters) {
				// 	if (filters.program_type.includes(',')) {
				// 		programType = filters.program_type.split(',')[0];
				// 	} else {
				// 		programType = filters.program_type;
				// 	}
				// }
				programType = filters.program_type;

				if (foundPlace != null) {
					var parsedPlaceSlug = foundPlace.slug.split('/');
					return `${route}/${(language != null ? (language.language + '/') : '')}${parsedPlaceSlug[parsedPlaceSlug.length - 1]}/${school.params.school_name}${filters.duration && page !== 'universities' ? '?duration=' + filters.duration + '&program_start_date=' + filters.program_start_date + '&program_type=' + programType : '?program_start_date=' + filters.program_start_date + '&program_type=' + programType}`;
				} else {
					return `${route}/${(language != null ? (language.language + '/') : '')}${page === 'universities' ? 'university-detail' : 'school-detail'}/${school.slug}${filters.duration && page !== 'universities' ? '?duration=' + filters.duration + '&program_start_date=' + filters.program_start_date + '&program_type=' + programType : '?program_start_date=' + filters.program_start_date + '&program_type=' + programType}`;
				}

			},
			cloneObj(obj) {
				return Object.assign({}, obj)
			},
			renameKey(object, key, newKey) {
				const clonedObj = this.cloneObj(object);
				const targetKey = clonedObj[key];
				delete clonedObj[key];
				clonedObj[newKey] = targetKey;
				return clonedObj;
			},
			handleResizeEvent() {
				this.innerWidth = window.innerWidth
			},
			parseParams(search) {
				return Object.fromEntries(new URLSearchParams(search));
			},
			formatPrice(value) {
				return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
			},
			addUrlParameter(name, value) {
				const url = new URL(window.location.href)
				let params = new URLSearchParams(url.search);
				params.set(name, value)
				const newRelativePathQuery = window.location.pathname + '?' + params.toString();
				history.pushState(null, '', newRelativePathQuery);
			},
			deleteUrlParameter(name) {
				const url = new URL(window.location.href);
				let params = new URLSearchParams(url.search);
				params.delete(name);
				const newRelativePathQuery = window.location.pathname + '?' + params.toString();
				history.pushState(null, '', newRelativePathQuery);
			},
			getMonday(d) {
				d = new Date(d);
				const day = d.getDay(),
					diff = d.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is sunday
				return new Date(d.setDate(diff));
			},
			addWeeksToDate(dateObj, numberOfWeeks) {
				dateObj.setDate(dateObj.getDate() + numberOfWeeks * 7);
				return dateObj;
			}
		}
	})
	const components = {
		'detail-search': () => import('./components/DetailSearch.vue'),
		'profile-option-modal': () => import('./components/modals/ProfileOptionModal.vue'),
		'notifications-modal': () => import('./components/modals/NotificationsModal.vue'),
		'notifications': () => import('./components/Notifications.vue'),
		'franch-section': () => import('./components/FranchSection'),
		'contact-me-section': () => import('./components/ContactMeSection.vue'),
		'you-tube-player-modal': () => import('./components/modals/YouTubePlayerModal.vue'),
		'franchise-form': () => import('./components/FranchiseForm.vue'),
		'search-input': () => import('./components/SeachInput'),
		'get-an-offer': () => import('./components/GetAnOfferForm'),
		'gallery-detail-modal': () => import('./components/GalleryDetailModal'),
		'advertising-modal': () => import('./components/modals/AdvertisingModal.vue'),
		'agency-modal-form': () => import('./components/agency/AgencyModal.vue'),
		'agency-email-modal-form': () => import('./components/agency/AgencyEmailModal.vue'),
		'contact-form': () => import('./components/ContactForm'),
		'agency-contact-form': () => import('./components/agency/AgencyContactForm'),
		'endless-camp-apply-form': () => import('./components/EndlessCampApplyForm.vue'),
		'apply-to-catalogs': () => import('./components/ApplyToCatalogsForm'),
		'profile-button': () => import('./components/profileButton'),
		'contents-section': () => import('./components/ContentsSection'),
		'video-player-modal': () => import('./components/modals/VideoPlayerModal'),
		'player-button': () => import('./components/PlayerButton.vue'),
		'blog-search': () => import('./components/BlogSearch.vue'),
		'branches-search': () => import('./components/BranchesSearch.vue'),
		'profile-page': () => import('./components/profile/ProfilePage.vue'),
		'list-page-search': () => import('./components/ListPageSearch.vue'),
		'event-search': () => import('./components/EventSearch.vue'),
		'currency-dropdown': () => import('./components/form-items/CurrencyDropdown'),
		'dropdown': () => import('./components/form-items/dropdown'),
		'program-detail-page': () => import('./components/ProgramDetailPage.vue'),
		'compare-page': () => import('./components/ComparePage.vue'),
		'university-detail-page': () => import('./components/UniversityDetailPage.vue'),
		'language-school-detail-page': () => import('./components/LanguageSchoolDetailPage.vue'),
		'language-schools-list': () => import('./components/LanguageSchoolsList.vue'),
		'endless-camps-courses-list': () => import('./components/EndlessCampsCoursesList.vue'),
		'endless-camps-detail-page': () => import('./components/EndlessCampsDetailPage.vue'),
		'agency-list': () => import('./components/agency/AgencyListPage.vue'),
		'multiple-select': () => import('./components/form-items/MultipleSelect.vue'),
		'custom-select': () => import('./components/form-items/CustomSelect.vue'),
		'book-appointment-modal': () => import('./components/modals/BookAppointmentModal.vue'),
		'exam-detail-page': () => import('./components/ExamDetailPage.vue'),
		'application-step1': () => import('./components/profile/application/step1.vue'),
		'application-step2': () => import('./components/profile/application/step2.vue'),
		'application-step3': () => import('./components/profile/application/step3.vue'),
		'application-step4': () => import('./components/profile/application/step4.vue'),
		'application-step5': () => import('./components/profile/application/step5.vue'),
		'application-step6': () => import('./components/profile/application/step6.vue'),
		'application-step7': () => import('./components/profile/application/step7.vue'),
		'application-step8': () => import('./components/profile/application/step8.vue'),
		'application-timeline': () => import('./components/profile/application/applicationTimeline.vue'),
		'author-card': () => import('./components/AuthorCard.vue'),
		'search-page': () => import('./components/SearchPage.vue'),

	};
	 if(document.readyState === 'complete'){
		 const vueApp = document.querySelectorAll('.vue-app')
		 vueApp.forEach((vue, index) => {
			 vue.classList.add(`vue-app-${index}`)
			 new Vue({
				 el: `.vue-app-${index}`,
				 components:{...components},
				 store,
				 axios
			 });
		 })
	 } else{
		 window.addEventListener('load', function () {
			 const vueApp = document.querySelectorAll('.vue-app')
			 vueApp.forEach((vue, index) => {
				 vue.classList.add(`vue-app-${index}`)
				 new Vue({
					 el: `.vue-app-${index}`,
					 components:{...components},
					 store,
					 axios
				 });
			 })
		 })
	 }

	 return apiToken

}
const token = waitForLocalStorage('api-token',appInstance)


import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');
window.Echo = new Echo({
	broadcaster: 'pusher',
	key:process.env.MIX_PUSHER_APP_KEY,
	cluster: process.env.MIX_PUSHER_APP_CLUSTER,
	wsHost: 'socket.yesspartners.com',
	wsPort: 6001,
	wssPort: 6001,
	forceTLS: false,
	encrypted: true,
	disableStats: true,
	enabledTransports: ['ws', 'wss'],
	authorizer: (channel, options) => {
		return {
			authorize: (socketId, callback) => {
				fetch(process.env.MIX_ENDLESS_API_BASE_URL + '/broadcasting/auth', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'Accept': 'application/json',
						Authorization: 'Bearer ' + token,
					},
					body: JSON.stringify({
						socket_id: socketId,
						channel_name: channel.name,
					}),
				})
					.then((response) => response.json())
					.then((response) => {
						callback(null, response)
					})
					.catch((error) => {
						callback(error)
					})
			},
		}
	},
});
